import gql from "graphql-tag";

export const DeleteSupplyBudgetComment = gql`
  mutation DeleteSupplyBudgetComment($id: String!) {
    deleteSupplyBudgetComment(id: $id)
  }
`;
